import { IRequest } from "../interfaces/authentication.interface";
import { ILegalResponse } from "../interfaces/legal.interface";
import { strapiRequest } from "./requests.service";

export const getLegal = async (locale: string): Promise<IRequest<string>> => {
    try {
        const query = `
            query Content {
                content: legalContent {
                    content: legalContent
                }
            }
            `;

        const variables = {
            locale
        };

        const response = await strapiRequest.post<ILegalResponse>(`/graphql`, {
            operationName: "Content",
            query,
            variables
        });

        return { success: true, data: response.data.data.content?.content ?? "" };
    } catch (error: any) {
        return { success: false, data: [] as any };
    }
};
